import { createSlice } from "@reduxjs/toolkit";
import { ForgotPasswordResponse } from "../types";

const initialState: ForgotPasswordResponse = {
  status: false,
  result: {
    user_code: "",
  },
  message: "",
};

const forgotPasswordReducer = createSlice({
  name: "forgotPassword",
  initialState: initialState,
  reducers: {
    fetchForgotPasswordUserSuccess(state, action) {
      return {
        ...state,
        result: {
          user_code: action.payload.result.user_code,
        },
      };
    },
  },
});
export default forgotPasswordReducer.reducer;

export const { fetchForgotPasswordUserSuccess } = forgotPasswordReducer.actions;
